import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/metaPixel';
export function BonusSection() {
  return <section className="py-24 bg-cream relative" data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-38">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark mb-6" data-id="element-39">
            🎁 Plus, Get These Exclusive Bonuses — FREE!
          </h2>
          <p className="text-xl text-muted" data-id="element-40">
            Order today and receive two additional resources to support your
            child's emotional journey.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-41">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-6 sm:p-8 shadow-warm border border-gray-100 flex flex-col items-center text-center" data-id="element-42">
            <motion.div whileHover={{
            scale: 1.05,
            rotate: -2
          }} className="mb-8 relative" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/vFPPqLVpG2pHrJByJX25jq/ChatGPT_Image_23_oct_2025,_15_48_29.png" alt="Emotion Dictionary" className="w-full max-h-[350px] object-contain rounded-2xl shadow-md" data-id="element-44" />
            </motion.div>
            <span className="bg-accent/20 text-yellow-700 font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-45">
              BONUS #1
            </span>
            <h3 className="text-2xl font-heading font-bold text-dark mb-3" data-id="element-46">
              Emotion Dictionary
            </h3>
            <p className="text-muted mb-6 flex-grow" data-id="element-47">
              A beautifully illustrated reference guide with 12 emotions.
              Perfect for helping children identify and name what they're
              feeling.
            </p>
            <div className="bg-peach/50 w-full py-3 rounded-xl font-semibold text-primary" data-id="element-48">
              Value: $9.99 — Yours FREE
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-6 sm:p-8 shadow-warm border border-gray-100 flex flex-col items-center text-center" data-id="element-49">
            <motion.div whileHover={{
            scale: 1.05,
            rotate: 2
          }} className="mb-8 relative" data-id="element-50">
              <img src="https://cdn.magicpatterns.com/uploads/ugPnqM5dRm1uKFh6x47h4K/ChatGPT_Image_23_oct_2025,_15_57_21.png" alt="Calm Corner Poster" className="w-full max-h-[350px] object-contain rounded-2xl shadow-md" data-id="element-51" />
            </motion.div>
            <span className="bg-accent/20 text-yellow-700 font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-52">
              BONUS #2
            </span>
            <h3 className="text-2xl font-heading font-bold text-dark mb-3" data-id="element-53">
              Calm Corner Poster
            </h3>
            <p className="text-muted mb-6 flex-grow" data-id="element-54">
              A printable poster with 7 calming strategies kids can use
              independently. Hang it in their room or classroom for instant
              access.
            </p>
            <div className="bg-peach/50 w-full py-3 rounded-xl font-semibold text-primary" data-id="element-55">
              Value: $7.99 — Yours FREE
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-56">
          <div className="text-2xl font-heading font-bold text-dark mb-8" data-id="element-57">
            Total Value:{' '}
            <span className="line-through text-muted/70" data-id="element-58">$24,9</span>{' '}
            <span className="text-primary" data-id="element-59">→ Today Just $14.99</span>
          </div>
          <a href="#cta" onClick={() => trackEvent('ViewContent', {
          content_name: 'Claim Kit + Bonuses CTA'
        })} className="inline-flex justify-center items-center bg-primary hover:bg-primary/90 text-white px-10 py-5 rounded-full font-bold text-xl transition-all hover:shadow-warm hover:-translate-y-1 w-full sm:w-auto" data-id="element-60">
            Claim Your Kit + Bonuses
          </a>
        </motion.div>
      </div>
    </section>;
}